import { Step as StepBase } from './Step';
import { StepCss as EmoStep, StepConnectorCss as EmoStepConnector } from './style';

const styledComponents = {
  StepComp: EmoStep,
  StepConnectorComp: EmoStepConnector
};

export const StepStyled = props => <StepBase components={styledComponents} {...props} />;

StepStyled.displayName = 'StepStyled';
